import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import '../../admin.css';

const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard' },
  { to: '/admin/backgrounds', label: 'Backgrounds' },
  { to: '/admin/events', label: 'Events' },
  { to: '/admin/news', label: 'News' },
  { to: '/admin/members', label: 'Members' },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar__header">
          <h1>ICI CMS</h1>
          <p>Content management</p>
        </div>
        <nav className="admin-sidebar__nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `admin-sidebar__link${isActive ? ' admin-sidebar__link--active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar__footer">
          <a href="/" className="admin-sidebar__view-site">
            ← View site
          </a>
          <button type="button" onClick={handleSignOut} className="admin-sidebar__signout">
            Sign out
          </button>
        </div>
      </aside>
      <main className="admin-main">
        <div className="admin-main__inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
